import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import "./styles/Cash.css";

const API = "https://okna.co.tz/mrms/CashReport.php";
const ITEMS_PER_PAGE = 10;

export default function Cash() {
  const token = localStorage.getItem("token");

  const [rows, setRows] = useState([]);
  const [opening, setOpening] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    try {
      const res = await fetch(`${API}?token=${token}`);
      const data = await res.json();

      if (data.error) {
        Swal.fire("Error", data.error, "error");
        return;
      }

      setRows(data.rows || []);
      setOpening(data.opening_balance || 0);
    } catch {
      Swal.fire("Error", "Failed loading report", "error");
    }
  };

  // ================= TOTALS =================
  const totals = rows.reduce(
    (acc, r) => {
      acc.cash += r.cash || 0;
      acc.card += r.card || 0;
      acc.mpesa += r.mpesa || 0;
      acc.tigo += r.tigo || 0;
      acc.selcom += r.selcom || 0;
      acc.total += r.total || 0;
      acc.system += r.system_sales || 0;
      acc.expenses += r.expenses || 0;
      return acc;
    },
    {
      cash: 0,
      card: 0,
      mpesa: 0,
      tigo: 0,
      selcom: 0,
      total: 0,
      system: 0,
      expenses: 0,
    }
  );

  // ================= EXCEL EXPORT =================
  const generateExcel = () => {
    if (rows.length === 0) {
      Swal.fire("No Data", "", "warning");
      return;
    }

    const data = [];

    data.push(["DAILY CASH BOOK REPORT"]);
    data.push([]);
    data.push(["Beginning Balance", opening]);
    data.push([]);

    data.push([
      "DATES",
      "CASH",
      "CRDB BANK",
      "M-PESA",
      "MIXX BY YAS",
      "SELCOM",
      "TOTAL",
      "SYSTEM SALES",
      "DIFFERENCE",
      "EXPENSES",
      "CLOSING BALANCE",
    ]);

    rows.forEach((r) => {
      data.push([
        r.date,
        r.cash || 0,
        r.card || 0,
        r.mpesa || 0,
        r.tigo || 0,
        r.selcom || 0,
        r.total || 0,
        r.system_sales || 0,
        r.difference || 0,
        r.expenses || 0,
        r.closing_balance || 0,
      ]);
    });

    data.push([]);

    data.push([
      "TOTAL",
      totals.cash,
      totals.card,
      totals.mpesa,
      totals.tigo,
      totals.selcom,
      totals.total,
      totals.system,
      "",
      totals.expenses,
      "",
    ]);

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CashBook");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buffer]), "Daily_Cash_Report.xlsx");
  };

  // ================= PAGINATION =================
  const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);
  const start = (currentPage - 1) * ITEMS_PER_PAGE;
  const pageData = rows.slice(start, start + ITEMS_PER_PAGE);

  const formatNumber = (value) => {
    return (value || 0).toLocaleString("en-US");
  };

  return (
    <div className="cash-container">

      <div className="cash-header">
        <h2 className="cash-title">DAILY CASH BOOK REPORT</h2>

        <button className="excel-btn" onClick={generateExcel}>
          Download Report
        </button>
      </div>

      <div className="cash-table-wrapper">
        <table className="cash-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Cash</th>
              <th>CRDB Bank</th>
              <th>M-Pesa</th>
              <th>Mixx By Yas</th>
              <th>Selcom</th>
              <th>Total</th>
              <th>System Sales</th>
              <th>Difference</th>
              <th>Expenses</th>
              <th>Closing Balance</th>
            </tr>
          </thead>

          <tbody>
            {pageData.map((r, i) => (
              <tr key={i}>
                <td>{r.date}</td>
                <td>{formatNumber(r.cash)}</td>
                <td>{formatNumber(r.card)}</td>
                <td>{formatNumber(r.mpesa)}</td>
                <td>{formatNumber(r.tigo)}</td>
                <td>{formatNumber(r.selcom)}</td>
                <td>{formatNumber(r.total)}</td>
                <td>{formatNumber(r.system_sales)}</td>

                <td style={{ color: r.difference !== 0 ? "red" : "green" }}>
                  {formatNumber(r.difference)}
                </td>

                <td style={{ color: "red" }}>
                  {formatNumber(r.expenses)}
                </td>

                <td>{formatNumber(r.closing_balance)}</td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="totals-row">
              <td><b>TOTAL</b></td>
              <td>{formatNumber(totals.cash)}</td>
              <td>{formatNumber(totals.card)}</td>
              <td>{formatNumber(totals.mpesa)}</td>
              <td>{formatNumber(totals.tigo)}</td>
              <td>{formatNumber(totals.selcom)}</td>
              <td>{formatNumber(totals.total)}</td>
              <td>{formatNumber(totals.system)}</td>
              <td>-</td>
              <td>{formatNumber(totals.expenses)}</td>
              <td>-</td>
            </tr>
          </tfoot>

        </table>
      </div>

      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </button>

        <span>{currentPage} / {totalPages || 1}</span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

    </div>
  );
}


